<template>
  <button type="button" class="btn btn-primary btn-sm rounded-pill position-relative" data-placement="bottom" data-toggle="tooltip"
          data-coreui-toggle="offcanvas" data-coreui-target="#notificationArea" aria-controls="notificationArea">
    <i class="cil-envelope-closed"></i>
    <span v-if="multipleUnreadCount" class="position-absolute top-5 start-100 translate-middle p-1 bg-danger rounded-circle"></span>
  </button>
</template>

<script>
export default {
  name: "NotificationButton",
  props: {
    unreadCount: {
      type: Number,
      required: true
    }
  },
  computed: {
    multipleUnreadCount() {
      return this.unreadCount > 0;
    }
  }
}
</script>
